import { Container, Text } from '@loomhq/lens';
import * as React from 'react';

import { ROLLOUT_SIGNUP_MODAL_FROM_SHARE_PAGE } from 'constants/featureFlag';

import FeatureFlaggedComponent from 'components/feature-flag-wrapper';

import styles from './styles.module.less';

const PasswordFeedback = ({ passwordViolations, containerProps }) => {
  if (!passwordViolations?.length) {
    return null;
  }

  return (
    <Container
      radius="medium"
      padding="medium"
      backgroundColor="grey2"
      {...containerProps}
    >
      <FeatureFlaggedComponent // Show link instead of modal when FF is off
        flag={ROLLOUT_SIGNUP_MODAL_FROM_SHARE_PAGE}
        activationValues={[false]}
      >
        {passwordViolations.includes('MIN_LENGTH') && (
          <Text> - Password needs at least 8 characters</Text>
        )}
        {passwordViolations.includes('MAX_LENGTH') && (
          <Text>- Password must have less or equal to 64 characters</Text>
        )}
        {(passwordViolations.includes('UPPER_CASE') ||
          passwordViolations.includes('LOWER_CASE')) && (
          <Text>
            - Password must have at least one lower and one upper case character
          </Text>
        )}
        {passwordViolations.includes('SYMBOL') && (
          <Text>- Password needs at least one symbol ($, !, @, _, *, etc)</Text>
        )}
        {passwordViolations.includes('NUMBER') && (
          <Text>- Password must include one number or more</Text>
        )}
      </FeatureFlaggedComponent>
      <FeatureFlaggedComponent // Show link instead of modal when FF is off
        flag={ROLLOUT_SIGNUP_MODAL_FROM_SHARE_PAGE}
        activationValues={[true]}
      >
        <ul className={styles.bulletedList}>
          {passwordViolations.includes('NUMBER') && (
            <li>
              <Text size="small">Password needs at least one number</Text>
            </li>
          )}
          {passwordViolations.includes('SYMBOL') && (
            <li>
              <Text size="small">
                Password needs at least one symbol (like $!@_*)
              </Text>
            </li>
          )}
          {passwordViolations.includes('UPPER_CASE') && (
            <li>
              <Text size="small">
                Password needs at least one upper case character
              </Text>
            </li>
          )}
          {passwordViolations.includes('LOWER_CASE') && (
            <li>
              <Text size="small">
                Password needs at least one lower case character
              </Text>
            </li>
          )}
          {passwordViolations.includes('MIN_LENGTH') && (
            <li>
              <Text size="small">Password needs at least 8 characters</Text>
            </li>
          )}
          {passwordViolations.includes('MAX_LENGTH') && (
            <li>
              <Text size="small">
                Password needs less than or equal to 64 characters
              </Text>
            </li>
          )}
        </ul>
      </FeatureFlaggedComponent>
    </Container>
  );
};

export default PasswordFeedback;
